import { FormTemplateStateEnum, FormTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import type { FormTemplateInsertData } from '../handleExtOpsIntegrationEnabled'
import type { FormConfig } from '@omnea-app/packages/universal/formBuilder/form'

// Question names are kept in sync with the price-intelligence operation's output variableIds
// (see omnea-extops libs/integrations/tropic .../priceBenchmarkVariables.ts) so the completion handler
// can prefill them by key. The full benchmark JSON (`tropicBenchmark`) rides through executionOutput
// separately and is read by the result view — it is not a form question.
export const TropicQuestionIds = {
  savingsOpportunity: 'savingsOpportunity',
  benchmarkSummary: 'benchmarkSummary',
}

const config: FormConfig = {
  logic: {},
  pages: [
    {
      id: '1b8ff467-ddc9-4773-a0f8-4333aed65480',
      name: 'benchmark-overview',
      title: 'Price Intelligence',
      questions: [
        {
          id: 'efe67dfc-2371-4576-9192-bcc1d32ed069',
          name: TropicQuestionIds.savingsOpportunity,
          type: 'dropdown',
          title: 'Savings opportunity',
          description:
            'Tropic’s overall savings-opportunity rating for this quote. One of: Low, Moderate, High, No recommendation, Unavailable. Use it to drive conditional logic downstream',
          visibleIf: [],
          isRequired: false,
          options: [
            { id: '7f2f31bc-d255-4d4f-8835-9c4c402f0148', value: 'low', label: 'Low', role: 'DEFAULT' },
            { id: 'd992097b-db2c-4835-a8eb-f53f6755a94e', value: 'moderate', label: 'Moderate', role: 'DEFAULT' },
            { id: '7d16d3b2-7f25-45b7-9d6a-a7834e758001', value: 'high', label: 'High', role: 'DEFAULT' },
            {
              id: '316ea685-f845-4668-97e7-406a0110c61c',
              value: 'no_recommendation',
              label: 'No recommendation',
              role: 'DEFAULT',
            },
            { id: '51b48e36-514c-4d31-a008-a0d700952b3a', value: 'unavailable', label: 'Unavailable', role: 'DEFAULT' },
          ],
        },
        {
          id: '9b18a533-03e0-45cc-90c8-cd3745c1089d',
          name: TropicQuestionIds.benchmarkSummary,
          type: 'text',
          title: 'Benchmark summary',
          description: 'Analyst commentary or summary of the benchmark result',
          visibleIf: [],
          isRequired: false,
        },
      ],
    },
  ],
  enableAiSummary: true,
  enableAiAutoFill: false,
}

// TODO (INT-508): Migrate this to use form template questions to lock down the question IDs
// TODO (WINT-645): Update config to match the new form template question schema
export const formTemplate = {
  title: 'Price Intelligence',
  state: FormTemplateStateEnum.PUBLISHED,
  type: FormTypeEnum.EXTERNAL_OPERATION,
  integration: 'tropic',
  description: 'This form is used to capture the output of the price intelligence integration',
  config,
} satisfies FormTemplateInsertData

export const TropicQuestionTemplatesArray = config.pages.flatMap((page) => page.questions)
export const TropicQuestionIdsArray = Object.values(TropicQuestionIds)
